export default (err, message) => {
  if (err.graphQLErrors[0].message && !err.graphQLErrors[0].message.includes('=')) {
    return err.graphQLErrors[0].message
  }
  return message ? message : 'Ocorreu um erro ao processar sua solicitação.'
}
